/**
 * Données gardées sur le poste pour travailler sans connexion :
 *  - référence (patients : identité minimale, types de consultation et prix,
 *    moyens de paiement, médecins), rafraîchie toutes les 15 minutes ;
 *  - dernière copie de la salle d'attente et de l'agenda, affichée si le
 *    serveur ne répond plus.
 * Tout est effacé à la déconnexion (sauf les saisies pas encore envoyées).
 */
import store from '@/store'
import { kv, file } from './stockage'
import { etat } from './etat'

const ECRANS_COPIES = [/^salle-attente(\?|$)/, /^rendez-vous(\?|$)/, /^rendez-vous\/medecins/]
const PERMISSIONS = ['RDV_GERER', 'CONSULT_CREATE', 'SALLE_ATTENTE', 'CONSULT_PAIEMENT', 'PATIENT_CREATE']

function prefixe() {
  const u = store.state.user
  return u ? `u${u.id}:` : 'anonyme:'
}

export function peutTravaillerHorsLigne() {
  return store.getters.hasAnyPermission ? store.getters.hasAnyPermission(PERMISSIONS) : false
}

/** Adresse (relative à /api/v1) + paramètres → clé de copie, ou null si l'écran n'est pas copié. */
export function cleCopie(config) {
  const url = String(config?.url || '').replace(/^\//, '')
  if ((config?.method || 'get').toLowerCase() !== 'get' || !ECRANS_COPIES.some(r => r.test(url))) return null
  const params = config.params ? '?' + new URLSearchParams(Object.entries(config.params).filter(([, v]) => v !== undefined && v !== null)).toString() : ''
  return prefixe() + 'copie:' + url + params
}

export async function garderCopie(cle, data) {
  await kv.ecrire(cle, { data, le: new Date().toISOString() })
}

export async function lireCopie(cle) {
  return kv.lire(cle)
}

export async function chargerReference(api) {
  if (!store.state.user || !peutTravaillerHorsLigne()) return null
  try {
    const r = await api.custom('hors-ligne/reference', 'GET')
    await kv.ecrire(prefixe() + 'reference', r.data)
    etat.referenceLe = r.data.genereLe
    return r.data
  } catch (e) {
    return null
  }
}

export async function lireReference() {
  const r = await kv.lire(prefixe() + 'reference')
  if (r) etat.referenceLe = r.genereLe
  return r || null
}

/**
 * À la fin de la session (déconnexion, session expirée, compte désactivé) :
 * plus de copie des patients sur le poste, ni de saisies déjà envoyées.
 * Seules restent les saisies pas encore envoyées, pour ne pas perdre de soins.
 */
export async function effacerDonneesLocales() {
  try {
    await kv.vider()
    for (const i of await file.liste()) {
      if (i.statut === 'ENVOYE') await file.supprimer(i.id)
    }
  } catch (e) {
    // stockage indisponible : rien à effacer
  }
  etat.referenceLe = null
  etat.copieAffichee = null
}

let minuterie = null
export function demarrerRafraichissement(api) {
  clearInterval(minuterie)
  chargerReference(api)
  minuterie = setInterval(() => { if (!etat.horsLigne) chargerReference(api) }, 15 * 60 * 1000)
}
